module.exports = __webpack_public_path__ + "img/00035.d8098efd.webp";